import { useEffect, useState } from 'react';
import { getIncidents } from '../api/api';

/**
 * Maps alert_id -> incident, for any page that needs to know whether a
 * CRITICAL/HIGH alert (which auto-creates an incident server-side, BR-039)
 * already has one — so it can link straight there instead of offering
 * nothing. There is no "get incident(s) by alert id" endpoint, so this
 * fetches the incident list once and indexes it client-side.
 *
 * @param enabled skip the fetch entirely when nothing on the page currently
 *   needs it (e.g. AlertDetailPage viewing a MEDIUM/LOW alert)
 */
function useIncidentsByAlertId(enabled = true) {
  const [incidentsByAlertId, setIncidentsByAlertId] = useState(new Map());

  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    getIncidents()
      .then((res) => {
        if (cancelled) return;
        const list = Array.isArray(res.data) ? res.data : res.data?.incidents || res.data?.content || [];
        const map = new Map();
        list.forEach((incident) => {
          if (incident.alert_id) map.set(incident.alert_id, incident);
        });
        setIncidentsByAlertId(map);
      })
      .catch(() => {
        if (!cancelled) setIncidentsByAlertId(new Map());
      });
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return incidentsByAlertId;
}

export default useIncidentsByAlertId;
